
import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getFontSize } from '../../utils/commonFun';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const TextPropsDefaults = {
    text: '',
};
export const CustomText = (_a)=> {
    var _b, _c, _d, _e, _f, _g, _h, _i;
    var style = _a.style, props = _a.props, formClientWidth = _a.formClientWidth;
    const isMobile = formClientWidth <= 480;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        fontSize: getFontSize(style?.fontSize, isMobile),
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_f = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _f !== void 0 ? _f : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
    };
    const successColor = (_i = style === null || style === void 0 ? void 0 : style.successColor) !== null && _i !== void 0 ? _i : undefined;
    const textColor = (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined;
    var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    var successText = (_h = props === null || props === void 0 ? void 0 : props.successText) !== null && _h !== void 0 ? _h : undefined;
    // if (props === null || props === void 0 ? void 0 : props.markdown) {
    //     return <EmailMarkdown style={wStyle} markdown={text}/>;
    // }
    const finalText = _a?.unSubData?.result === true ? successText : text
    const html = finalText?.replace(/<([a-zA-Z]+)([^>]*)style="([^"]*?)font-size:\s*(\d+)px([^"]*?)"(.*?)>/g, (match, tag, beforeStyle, styleStart, fontSize, styleEnd, afterStyle) => {
        
        const newStyle = `${styleStart}font-size: ${getFontSize(fontSize, isMobile)}px${styleEnd}`.trim();

        return `<${tag}${beforeStyle}style="${newStyle}" ${afterStyle}>`;
    });
    return <div style={{
        ...wStyle,
        color: _a?.unSubData?.result === true ? (successColor || textColor) : textColor
    }} dangerouslySetInnerHTML={{ __html: html }}>
        {/* {_a?.unSubData?.result === true ? (successText) : text} */}
    </div>;
}
